const assetUrls = import.meta.glob(
  "/src/assets/**/*.{png,jpg,jpeg,gif,svg,webp,ico}",
  {
    eager: true,
    query: "?url",
    import: "default",
  }
);

const resolveAssetPath = (p) => {
  if (!p) return p;
  if (p.startsWith("/")) return p;
  return "/src/" + p;
};

globalThis.require = (p) => assetUrls[resolveAssetPath(p)] ?? p;
